import { render, staticRenderFns } from "./ClassEndDialog.vue?vue&type=template&id=cbe554ce"
import script from "./ClassEndDialog.vue?vue&type=script&lang=js"
export * from "./ClassEndDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports